import { get, set } from "lodash";
import { StateParams } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../../records/grids";
import { ColDef } from "../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../app/records/server/serverUtility";

import "angular-formly";
import { IRowCommandEventArgs } from "../../../../records/grids/controller";
import { Record } from "../../../../records/server/crud";
import { FilterProvider } from "../../../../records/grids/columns/filters/FilterProvider";
import { $confirm } from "../../../../../@custom_types/confirm";
import { escapeAngularExpressionValueGetter } from "../../../../records/grids/cells/valueGetters";

const gridId = Symbol("main.download.files");
export class DownloadFileComponentController implements IOnInit {
  static $inject = [
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$compile",
    "$confirm",
  ];
  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  templateId = {};
  processActions!: any;

  constructor(
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    $compile: ICompileService,
    private readonly $confirm: $confirm
  ) {
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/machines/downloadMachineFile"
    );
    this.gridSettings = gridSettingsService.getGridSettings(gridId);

    this.columns = [
      columnDefinitionService.getLinkColDef({
        colId: "info",
        headerName: "Info",
        iconClass: "fa fa-info-circle text-primary",
        stateExpression: "main.machines.downloadFileDetail({ id: data.Id})",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Id",
        header: "Id",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "JobId",
        header: "JobId"
      }),

      columnDefinitionService.getStringColDef({
        field: "FileName",
        header: "File Name",
        hide: true,
        requiresPermission: "contractViewSensitive",
        cellRenderer: (params) => {
          const FileName = get(params.data, "FileName");
          const fileUrl = get(params.data, "Url");
          if (!fileUrl) {
            return "";
          }

          return `<a href="${fileUrl}" target="_blank">${"Download File"}</a>`;
        },
      }),
      
    ];
  }

  $onInit(): void {}

  onItemCommand(args: IRowCommandEventArgs<Record>) {
    switch (args.commandName) {
      case "delete":
        const actionId = args.data.Id;
        this.$confirm({
          text: "Are you sure you want to delete this action?",
        }).then(() =>
          this.serverUtility
            .sendApiRequest({
              method: "DELETE",
              url: `api/process/notification/${actionId}`,
            })
            .then(() => {
              args.gridApi.onNewDatasource();
            })
        );
        break;
    }
  }
}
